import React, { Component } from "react"

import { Card, CardBody, Col, Row } from "reactstrap"

const parts = window.location.hostname.split(".")
let last_index = -2
const last = parts[parts.length - 1]
const is_localhost = last === "localhost"
if (is_localhost) {
    console.log("is localhost, parts = ", parts)
}
const subdomain = parts.slice(0, last_index).join(".")

class Learning extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <Card>
                                {/* Render Email Top Tool Bar */}

                                <CardBody>
                                    <h4 className="mt-0 font-size-16">How to use the idexo app UI:</h4>

                                    <p>
                                        The application is meant primarily as a testing ground for developers. Sometimes it is hard to imagine how
                                        backend APIs will work without seeing some front-end examples. Everything you see in the UI uses our API that
                                        you can use in your own app.{" "}
                                    </p>
                                    <p>If you are interested in simply using the UI as an end-user that is fine too!</p>
                                    <p>
                                        In either case, to use the methods that require mainnet payments on different networks, you will need to
                                        set-up a paid account to use them. Until then, it's free!
                                    </p>
                                    <p>idexo team</p>
                                    <hr />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default Learning
